import { ProdutoAutorizado } from "@/contexts/laboratorio/produtoAutorizado/model/ProdutoAutorizado";
import { api } from "@/shared/api/api";

export const createProdutoAutorizadoApi = (accessToken?: string) => {
  const headers = { Authorization: `Bearer ${accessToken}` };

  const listAll = async () => {
    const { data } = await api.get<ProdutoAutorizado[]>(
      "/produtos-autorizados/todos",
      { headers }
    );
    return data;
  };

  return { listAll };
};
